import { render, staticRenderFns } from "./quiz.vue?vue&type=template&id=b2b99988&scoped=true"
import script from "./quiz.vue?vue&type=script&lang=js"
export * from "./quiz.vue?vue&type=script&lang=js"
import style0 from "./quiz.vue?vue&type=style&index=0&id=b2b99988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b99988",
  null
  
)

export default component.exports